var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("header", { staticClass: "boss-admin-bar" }, [
    _c("nav", { staticClass: "boss-admin-bar-nav" }, [
      _c("ul", { staticClass: "top-bar boss-admin-bar-nav-list" }, [
        _c(
          "li",
          { staticClass: "top-bar-left boss-admin-bar-logo" },
          [
            _c(
              "router-link",
              {
                staticClass: "boss-admin-bar-item",
                attrs: { to: { name: "dashboardTop" }, "data-test": "title" },
              },
              [
                _c("h1", { staticClass: "boss-admin-title" }, [
                  _c("img", {
                    staticClass: "pega-header-logo",
                    attrs: { src: require("@/assets/images/uki-logo-s.png") },
                  }),
                  _vm._v("\n            " + _vm._s(_vm.title) + "\n          "),
                ]),
              ]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c("li", { staticClass: "top-bar-right boss-admin-bar-myaccount" }, [
          _c(
            "ul",
            {
              staticClass: "dropdown menu boss-myaccount-container",
              attrs: { id: "user-menu", "data-dropdown-menu": "" },
            },
            [
              _c(
                "div",
                {
                  attrs: { "data-test": "refresh-icon" },
                  on: { click: _vm.refresh },
                },
                [
                  _c("span", {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: {
                          content:
                            "画面の再読み込みを行います。画面の表示崩れや、新しい機能が反映されていない時に押下してください。",
                        },
                        expression:
                          "{ content: '画面の再読み込みを行います。画面の表示崩れや、新しい機能が反映されていない時に押下してください。'}",
                      },
                    ],
                    staticClass:
                      "boss-icon boss-icon-redo-alt-solid pega-refresh",
                  }),
                ]
              ),
              _vm._v(" "),
              _c("li", { staticClass: "boss-myaccount-wrap" }, [
                _c(
                  "a",
                  {
                    staticClass: "boss-myaccount-link",
                    attrs: { "data-test": "company-name" },
                  },
                  [
                    _vm._v(_vm._s(_vm.currentUser.companyName)),
                    _c(
                      "span",
                      {
                        staticClass: "boss-myaccount-name",
                        attrs: { "data-test": "staff-name" },
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.roleLabel) +
                            " " +
                            _vm._s(_vm.currentUser.staffName)
                        ),
                      ]
                    ),
                    _vm._v(" 様"),
                  ]
                ),
                _vm._v(" "),
                _c("ul", { staticClass: "menu boss-myaccount-menu" }, [
                  !_vm.isCountScoutUserSimulation
                    ? _c(
                        "li",
                        { staticClass: "boss-myaccount-menu-item" },
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "boss-myaccount-menu-link",
                              attrs: {
                                to: { name: "settingAccountPassword" },
                                "data-test": "password-edit",
                              },
                            },
                            [
                              _vm._v(
                                "\n                  パスワード変更\n                "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          !_vm.isOutsourceeViewEntryUser
                            ? _c(
                                "router-link",
                                {
                                  staticClass: "boss-myaccount-menu-link",
                                  attrs: {
                                    to: { name: "settingAccountMail" },
                                    "data-test": "mail-edit",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                  メール受信設定\n                "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("li", { staticClass: "boss-myaccount-menu-item" }, [
                    _c(
                      "a",
                      {
                        staticClass: "boss-myaccount-menu-link",
                        attrs: { "data-test": "logout" },
                        on: { click: _vm.logout },
                      },
                      [_vm._v("ログアウト")]
                    ),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("li"),
            ]
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }